<template>
      <router-link to="/">
      <header>
    <div class="logo-container">
      <div class="logo-left">
        <img src="./assets/img/Knalbak_logo.svg" >
      </div>
      <div class="logo-right">
        <p>Knalbak</p>
      </div>
    </div>
  </header>
</router-link>
  <router-view/>
  <div v-if="!consentGiven" class="cookie-banner">
    <div class="cookie-center">
      <p>We gebruiken cookies voor een betere ervaring.</p>
      <div class="cookie-btns">
        <button class="cookie-reject" @click="declineCookies">Afwijzen</button>
        <button class="cookie-accept" @click="acceptCookies">Akkoord</button>
      </div>
    </div>
  </div>
  <footer>
    <router-link to="/privacy-cookies">Privacy en cookies</router-link>
  </footer>
</template>

<script>

export default {
  data() {
    return {
      consentGiven: false
    }
  },
  methods: {
    acceptCookies() {
      document.cookie = "cookieConsent=accepted; path=/; max-age=31536000";
      this.consentGiven = true;
      location.reload();
    },
    declineCookies() {
      document.cookie = "cookieConsent=declined; path=/; max-age=31536000";
      this.consentGiven = true;
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
  },
  mounted() {
    this.consentGiven = this.getCookie('cookieConsent') === 'accepted';
  }
}
</script>

<style>
.cookie-banner {
  height: 100vh;
  width: 100vw;
  padding-bottom: calc(100vh / 2 - 250px);
  z-index: 1000;
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.cookie-center {
  z-index: 1001;
  height: 500px;
  width: 600px;
  background-color: var(--license-yellow);
  border-radius: 6px;
  font-family: outfit, arial;
  font-size: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}

.cookie-btns {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.cookie-btns button {
  font-family: outfit, arial;
  font-size: 32px;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.1s;
  border: 0;
}

.cookie-btns .cookie-accept {
  background-color: var(--license-blue);
  padding: 5px;
  color: #fff;
}

.cookie-btns .cookie-accept:hover {
  transform: scale(1.1);
}

.cookie-btns .cookie-reject {
  color: var(--license-);
  background: transparent;
}

@media only screen and (max-width: 760px) {

  .cookie-center {
    z-index: 1001;
    height: 300px;
    width: 300px;
    font-size: 32px;
  }

  .cookie-btns button {
    font-family: outfit, arial;
    font-size: 24px;
    border-radius: 6px;
    cursor: pointer;
    transition: transform 0.1s;
    border: 0;
  }

  .cookie-btns .cookie-accept {
    background-color: var(--license-blue);
    padding: 5px;
    color: #fff;
  }

  .cookie-btns .cookie-accept:hover {
    transform: scale(1.1);
  }

  .cookie-btns .cookie-reject {
    color: var(--license-);
    background: transparent;
  }
}
</style>